import React, {PureComponent} from 'react';
import axios from "axios";
import Cookies from "universal-cookie";

import './Country.scss';
import {FETCH_URL} from "../../constants/ServerLinks";


export default class Country extends PureComponent {

    constructor(props) {
        super(props);

        this.fetchURL = FETCH_URL;
        this.cookies = new Cookies();
        this.world_skey = this.cookies.get('world_skey');
        this.config_number = this.cookies.get('config_number');
        this.country_name = this.cookies.get('country_name');
        this.state = {
            countryInfo: {
                "name": "",
                "overview": [],
                "nationalLanguage": "",
                "nationalSport": "",
                "population": "",
                "nationalBird": "",
                "nationalAnthem": "",
                "nationalFlower": "",
                "demographics": [],
                "economy": [],
                "geography": [],
                "politics": [],
            },
        };
        // Fetch the country from the backend
        this.fetchCountryInfo();
    }

    fetchCountryInfo = () => {

        axios.get(this.fetchURL + '/api/v1/wiki/country/', {
            params: {
                config_number: this.config_number,
                country_name: this.country_name,
            }
        })
            .then((response) => {
                // console.group("Country:fetchCountryInfo");
                // console.log(response.data.data);
                // console.groupEnd();
                if (response.data.success) {
                    let countryInfo = response.data.data;
                    this.setState({countryInfo: countryInfo});
                }
            })
            .catch((error) => {
                console.log(error.response);
            });
    };

    componentDidMount = () => {

        const flipperOuterContainer = document.querySelector('.flip-container');
        const flipperContainer = document.querySelector('.flipper');
        const frontContainer = document.querySelector('.front');
        if (frontContainer !== undefined) {
            const flipperHeight = frontContainer.clientHeight;
            flipperContainer.style.height = flipperHeight + 'px';

            const flipperBtns = document.querySelectorAll('.country-flip-item');

            for (var i = 0; i < flipperBtns.length; i++) {
                flipperBtns[i].addEventListener('click', function () {
                    const flipperTargetAtt = this.getAttribute('data-show');
                    const flipperTargetClass = '.countryInfo__' + flipperTargetAtt;
                    const flipperTarget = document.querySelector(flipperTargetClass);
                    const newFlipperHeight = flipperTarget.clientHeight + 'px';
                    flipperTarget.classList.add('country-flip-item-show');
                    flipperOuterContainer.classList.add('is-flipped');
                    flipperContainer.style.height = newFlipperHeight;
                    const exitBtn = flipperTarget.querySelector('.country-flip-exit');
                    // console.log(exitBtn);
                    window.scrollTo({
                        top: 0,
                        behavior: 'smooth',
                    });                    flipperOuterContainer.scrollTo(0, 0);
                    exitBtn.addEventListener('click', function () {

                        flipperOuterContainer.classList.remove('is-flipped');
                        flipperContainer.style.height = flipperHeight + 'px';
                        // console.log('hiya');
                        setTimeout(function () {
                            flipperTarget.classList.remove('country-flip-item-show')
                        }, 1000);
                    })
                });
            }
        }
    };

    render() {
        return (
            <div className={`dash__wrap np dash__countryWiki  ${this.props.display === "show" ? "active" : "hidden"}`}>
                <div className="dash__outer flex">
                    <div className="dash__inner dash__countryMap"/>
                    <div className="dash__inner p4 flip-container dash__countryInfo">
                        <div className="flipper">
                            <div className="front">
                                <div className="dash__panel">
                                    <h1>{this.state.countryInfo.name}</h1>
                                    <div className="countryInfo__stats fg2">
                                        <div className="stat">
                                            <h4>Population</h4>
                                            <p>{this.state.countryInfo.population}</p>
                                        </div>
                                        <div className="stat">
                                            <h4>National Language</h4>
                                            <p>{this.state.countryInfo.nationalLanguage}</p>
                                        </div>
                                        {/*<div className="stat">*/}
                                        {/*    {this.state.countryInfo.nationalAnthem != "" &&*/}
                                        {/*        <>*/}
                                        {/*            <h4>National Anthem</h4>*/}
                                        {/*            <p>{this.state.countryInfo.nationalAnthem}</p>*/}
                                        {/*        </>}*/}
                                        {/*</div>*/}

                                        {this.state.countryInfo.nationalAnthem != "" &&
                                            <>
                                                <div className="stat">
                                                <h4>National Anthem</h4>
                                                <p>{this.state.countryInfo.nationalAnthem}</p>
                                                </div>
                                            </>
                                        }
                                        {this.state.countryInfo.nationalBird != "" &&
                                            <>
                                                <div className="stat">
                                                <h4>National Bird</h4>
                                                <p>{this.state.countryInfo.nationalBird}</p>
                                                </div>
                                            </>
                                        }
                                        {this.state.countryInfo.nationalFlower != "" &&
                                            <>
                                                <div className="stat">
                                                <h4>National Flower</h4>
                                                <p>{this.state.countryInfo.nationalFlower}</p>
                                                </div>
                                            </>
                                        }
                                        <div className="stat">
                                            <h4>National Sport</h4>
                                            <p>{this.state.countryInfo.nationalSport}</p>
                                        </div>
                                    </div>
                                    <div className="countryInfo__intro">
                                        <h4 className="primaryColor">Overview</h4>
                                        {this.state.countryInfo.overview.map((item, index) => (
                                            <p key={`overview-${index}`}>{item}</p>
                                        ))}
                                    </div>
                                </div>
                                <div className="dash__panel pt2 fg2">
                                    <div className="dash__panelWrapOuter">
                                        <div
                                            className="dash__panelWrap oh relative angle-btn pb2 pt2 pl4 pr4 h10 shadow2 country-flip-item"
                                            data-show="demographics">
                                            <div className="icon-sm"/>
                                            <h3 className="mb2">Demographics</h3>
                                        </div>
                                    </div>
                                    <div className="dash__panelWrapOuter">
                                        <div
                                            className="dash__panelWrap oh relative angle-btn pb2 pt2 pl4 pr4 h10 shadow2 country-flip-item"
                                            data-show="geography">
                                            <div className="icon-sm"/>
                                            <h3 className="mb2">Geography</h3>
                                        </div>
                                    </div>
                                    <div className="dash__panelWrapOuter">
                                        <div
                                            className="dash__panelWrap oh relative angle-btn pb2 pt2 pl4 pr4 h10 shadow2 country-flip-item"
                                            data-show="politics">
                                            <div className="icon-sm"/>
                                            <h3 className="mb2">Politics</h3>
                                        </div>
                                    </div>
                                    <div className="dash__panelWrapOuter">
                                        <div
                                            className="dash__panelWrap oh relative angle-btn pb2 pt2 pl4 pr4 h10 shadow2 country-flip-item"
                                            data-show="economy">
                                            <div className="icon-sm"/>
                                            <h3 className="mb2">Economy</h3>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/*Front End*/}

                            <div className="back countryInfo__demographics">
                                <div className="dash__panel">
                                    <div className="country-flip-exit">
                                        <span>X</span>
                                    </div>
                                    <div className="dash__panelWrapOuter">
                                        <div
                                            className="dash__panelWrap oh relative angle-btn pb2 pt2 pl4 pr4 h10 shadow">
                                            <h2>Demographics</h2>
                                            <hr/>

                                            {this.state.countryInfo.demographics.map((item, index) => (
                                                <p key={`demo-${index}`}>{item}</p>
                                            ))}

                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="back countryInfo__geography">
                                <div className="dash__panel">
                                    <div className="country-flip-exit">
                                        <span>X</span>
                                    </div>
                                    <div className="dash__panelWrapOuter">
                                        <div
                                            className="dash__panelWrap oh relative angle-btn pb2 pt2 pl4 pr4 h10 shadow">
                                            <h2>Geography</h2>
                                            <hr/>

                                            {this.state.countryInfo.geography.map((item, index) => (
                                                <p key={`geo-${index}`}>{item}</p>
                                            ))}

                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="back countryInfo__politics">
                                <div className="dash__panel">
                                    <div className="country-flip-exit">
                                        <span>X</span>
                                    </div>
                                    <div className="dash__panelWrapOuter">
                                        <div
                                            className="dash__panelWrap oh relative angle-btn pb2 pt2 pl4 pr4 h10 shadow">
                                            <h2>Politics</h2>
                                            <hr/>

                                            {this.state.countryInfo.politics.map((item, index) => (
                                                <p key={`politics-${index}`}>{item}</p>
                                            ))}

                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="back countryInfo__economy">
                                <div className="dash__panel">
                                    <div className="country-flip-exit">
                                        <span>X</span>
                                    </div>
                                    <div className="dash__panelWrapOuter">
                                        <div
                                            className="dash__panelWrap oh relative angle-btn pb2 pt2 pl4 pr4 h10 shadow">
                                            <h2>Economy</h2>
                                            <hr/>

                                            {this.state.countryInfo.economy.map((item, index) => (
                                                <p key={`economy-${index}`}>{item}</p>
                                            ))}

                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        )
    }

}
